// Translations for the application
const translations = {
  en: {
    // Navigation
    brands: "Brands",
    products: "Products",
    shoppingCart: "My Media Plan",
    myMediaPlan: "My Media Plan",
    backToBrands: "Back to Brands",
    
    // Brand Detail
    region: "Region",
    type: "Type",
    visitWebsite: "Visit Website",
    brandNotFound: "Brand not found",
    brandReach: "Reach",
    brandPageviews: "Page Views",
    brandReachRegion: "Regional Reach",
    brandReadIntensity: "Reading Intensity",
    brandReachSocialFollowers: "Social Followers",
    
    // Description Block
    descriptionTitle: "Welcome to the Mediahuis Tariefcalculator",
    descriptionText: "With this tool, you can easily create and export your own media plan. Looking for digital, print, or audio advertising? We have it all! Build your plan, request a quote directly, and explore our extensive range of media brands. Our platform makes it super easy to discover options and create media plans that perfectly match your needs and budget.",
    
    // Slideshow
    slideTitle0: "Mediahuis Tariefcalculator",
    slideSubtitle0: "Discover our comprehensive media offerings",
    slideTitle1: "Adverteren via sterke merken",
    slideSubtitle1: "Ontdek al onze krachtige advertentieproducten op een rij",
    slideTitle2: "Podcast- en radiocampagnes",
    slideSubtitle2: "Val op tussen de oren via onze geliefde podcasts en radiostations",
    slideTitle3: "Digitale advertentieoplossingen",
    slideSubtitle3: "Bereik jouw doelgroep gericht via onze premium digitale platforms",
    slideTitle4: "Geïntegreerde mediacampagnes",
    slideSubtitle4: "Combineer diverse kanalen voor een krachtige en maximale impact",
    slideTitle5: "Regionale en lokale printmedia",
    slideSubtitle5: "Bereik doelgericht specifieke regio's via onze vertrouwde lokale merken",
    
    // Footer
    about: "About",
    quickLinks: "Quick Links",
    contact: "Contact",
    home: "Home",
    cart: "Media Plan",
    allRightsReserved: "All Rights Reserved",
    aboutDescription: "Mediahuis Tariefcalculator is a tool designed to help you calculate and manage your media planning costs.",
    moreInformation: "More Information",
    ratesAndSpecifications: "Rates and Specifications",
    deliverySpecifications: "Delivery Specifications",
    onlineAudiences: "Online Audiences",
    aboutUs: "About Us",
    
    // Cart
    emptyCart: "Your media plan is empty",
    addItemsToGetStarted: "Add some items from the product pages to get started",
    productDetails: "Product Details",
    mediumType: "Medium Type",
    calculation: "Calculation",
    calculationLabelsPrint: "Base Price × Pos. Factor × Format Factor",
    calculationLabelsDigital: "Reach × Base Price × Pos. Factor × Format Factor",
    calculationLabelsNieuwsbrief: "Price for Placement",
    calculationLabelFixedPrice: "Price per placement",
    price: "Price",
    total: "Total",
    clearCart: "Clear Plan",
    applyDiscount: "Add Discount",
    editDiscount: "Edit Discount ({discount}%)",
    removeDiscount: "Remove Discount",
    exportShoppingCart: "Export Plan",
    allItemsHaveDiscount: "All items have {discount}% discount applied",
    newItemsReceiveDiscount: "New items will automatically get the same discount",
    mixedDiscountsApplied: "Different discounts applied to items",
    checkIndividualDiscounts: "Check each item for its specific discount",
    discountLabel: "Discount: {discount}%",
    addDiscount: "Add Discount",
    
    // Calculation section
    calculatePrice: "Calculate Price",
    calculationDescription: "Calculate the total price based on your campaign's reach. Just enter the CPM value below.",
    enterBereik: "Enter Reach (CPM)",
    priceCalculation: "Price Calculation",
    formulaExplanation: "CPM × Base Price = Total Price",
    finalPrice: "Final Price",
    addToCart: "Add to Plan",
    addedToCart: "Added to plan!",
    additionalInformation: "More Info",
    additionalInfo: "Additional Info",
    showDetails: "Show Details",
    backToProvince: "Back to Search by Postcode",

    
    // Fixed Price Section
    fixedPriceItem: "Fixed Price Item",
    fixedPriceDescription: "This is a fixed price item. No calculation needed.",
    itemPrice: "Item Price",
    
    // Campaign Calculation
    campaignReach: "Campaign Reach",
    enterValue: "Enter value",
    totalImpressions: "total impressions",
    totalCampaignCost: "Total Campaign Cost",
    impressions: "Impressions",
    baseRate: "Base Rate",
    positionFactor: "Position Factor",
    formatFactor: "Format Factor",
    
    // Discount Modal
    applyDiscountToAllItems: "Apply Partner Discount to All Items",
    applyDiscountToItem: "Apply Partner Discount to Item",
    itemDiscountExplanation: "You can manually add a specific discount for this item",
    discountPercentage: "Partner discount percentage:",
    discountExplanation: "You can manually add specific discount for partners",
    cancel: "Cancel",
    apply: "Apply Partner Discount",
    applyToAllItems: "Apply This Discount to All Items",
    
    // Detail Views
    printMediaDetails: "Print Media Details",
    audioDetails: "Audio Details",
    onlineDetails: "Online Details",
    publication: "Publication",
    formatAndPosition: "Format & Position",
    pricing: "Pricing",
    website: "Website",
    formatAndPlacement: "Format & Placement",
    selectRowToViewDetails: "Select a row to view details",
    
    // Fields
    medium: "Medium",
    plaatsingsdag: "Placement day",
    tariefbasis: "Rate type",
    basisprijs: "Base price",
    doelgroep: "Target group",
    luisteraars: "Listeners",
    bereik: "Reach",
    impressions: "Impressions",
    station: "Station/Show",
    formatAndTimeslot: "Format & Timeslot",
    stationShow: "Station/Show",
    
    // CSV Viewer
    selectMediumtypeAndTitel: "Please select both Mediumtype and Titel to view results",
    noResultsFound: "No results found for the selected filters",
    productsHeroTitle: "Advertising Products",
    productsHeroSubtitle: "Browse our extensive catalog of advertising options across print, audio, and online media channels.",
    contactSales: "Contact Sales",
    
    // Filter Labels
    filterLabelMediumtype: "Medium Type",
    filterLabelTitel: "Title",
    filterLabelAandeel: "Page Share",
    filterLabelFormaat: "Format",
    filterLabelPositie: "Position",
    
    // Selection Modes
    filterSearch: "Manual Search",
    stepByStepSelection: "Selection Wizard",
    selectMediumtype: "Select Mediumtype",
    selectTitel: "Select Title",
    selectFormat: "Select Format",
    selectPosition: "Select Position",
    selectProduct: "Select Product",
    results: "Results",
    loading: "Loading Results",
    noResults: "No Results",
    filterResults: "Filter de resultaten",
    productDetail: "Product detail",
    filtersPreserved: "Your filter selections have been preserved in this view",
    backToMediumtype: "Back to Mediumtype",
    backToTitel: "Back to Titel",
    backToFormat: "Back to Format",
    backToPosition: "Back to Position",
    selectMediumtypeToContinue: "Please select a Mediumtype to continue",
    selectTitelToContinue: "Please select a Titel to continue",
    selectAandeel: "Select Page Share",
    selectAandeelFirst: "First select Page Share",
    selectAandeelToContinue: "Please select a Page Share to see available products",
    
    // Home Page
    homeSubtitle: "Calculate and manage ad rates across different media channels",
    startButton: "Start Your Plan",
    
    // AboutPage/Contact
    contactTitle: "Contact & Information",
    contactDesc: "Here you can find our contact details and more information about the Mediahuis rate calculator",
    contactDetails: "Contact Details",
    phone: "Phone",
    email: "Email",
    address: "Address",
    aboutTheCalculator: "About the Rate Calculator",
    calculatorPurpose: "With our rate calculator, you can quickly and easily check prices for advertisements across all our media. Search by media type, title, or region and immediately compare what suits you best.",
    calculatorFeatures: "What you can do with it:",
    featureSearch: "Quick search by media type, title, or region",
    featureCompare: "Compare prices of different options",
    featureExport: "Download your media plan",
    featureQuote: "Request a quote directly",
    
    // Feature blocks
    createMediaPlan: "Create a Media Plan",
    createMediaPlanDesc: "Build your custom media plan by selecting from our wide range of advertising options across different channels.",
    requestQuoteFeature: "Request a Quote",
    requestQuoteFeatureDesc: "Get personalized pricing and detailed information by requesting a quote from our sales team.",
    viewAllBrands: "View All Brands",
    viewAllBrandsDesc: "Explore our complete portfolio of media brands and discover the perfect channels for your advertising campaign.",
    
    // Custom Select Placeholders
    resetFilter: "Reset",
    selectMediumtypeFirst: "First select Mediumtype",
    selectMediumtypeAndTitelFirst: "First select Medium Type and Title",
    selectFormatFirst: "First select Format",
    selectGeneric: "Select {field}",
    
    // Old feature blocks (keeping for reference)
    browseProducts: "Browse Products",
    browseProductsDesc: "Check out our wide range of advertising options across print, audio, and online media channels.",
    manageCart: "Manage Your Plan",
    manageCartDesc: "Add products to your plan, apply partner discounts, and export your selections with just a few clicks.",
    applyDiscounts: "Apply Discounts",
    applyDiscountsDesc: "Easily add percentage discounts to individual items or your entire media plan in seconds.",
    
    // Campaign Calculation Instructions
    enterCampaignReach: "Enter your campaign's reach to see the price.",
    
    // Step Progress
    stepMediumtype: "Medium Type",
    stepTitel: "Title",
    stepFormat: "Format",
    stepPositie: "Position",
    stepAandeel: "Share",
    stepPosition: "Position",
    
    // Quote Request Form
    requestQuote: 'Get a Quote',
    quoteFormTitle: 'Request a Quote',
    name: 'Your Name',
    company: 'Company',
    email: 'Email',
    phone: 'Phone Number',
    remarks: 'Any Comments?',
    productSummary: 'Product Summary',
    cartSummary: 'Plan Summary',
    submit: 'Send Request',
    cancel: 'Cancel',
    requiredField: 'Please fill this in',
    invalidEmail: 'Please enter a valid email',
    successMessage: 'Thanks! Your quote request has been sent!',
    weWillContactYou: 'We\'ll be in touch soon.',
    
    // Region Search
    regionSearch: "Search by Zipcode",
    searchByRegion: "Search by Zipcode",
    selectProvince: "Select a province to see all available products in that region",
    selectProvincePrintOnly: "Select a province to see print media products in that region",
    printMediaOnly: "Print Media Only",
    province: "Province",
    selectProvinceToContinue: "Please select a province to see available products",
    productsInRegion: "Products in",
    printProductsInRegion: "Print Media Products in",
    backToProvince: "Back to Province",
    searchByZipcode: 'Search by Zipcode',
    enterZipcode: 'Enter zipcode (4 digits)',
    completeZipcode: 'Enter a complete 4-digit zipcode',
    enterCompleteZipcode: 'Please enter a complete 4-digit zipcode',
    or: 'OR',
    backToZipcode: 'Back to Zipcode',
    printProductsInZipcode: 'Print media products for zipcode',
    includingNationalProducts: 'including national products',
    selectProvinceOrZipcode: 'Please select a province or enter a zipcode to see available products',
    noRegionalTitles: 'No regional titles available for this area',
    selectFormat: 'Select Format',
    backToTitle: 'Back to Title',
    selectFormatToContinue: 'Please select a format to see available products',
    zipcodeNotFound: 'No specific regional products available for this zipcode',
    totalPrice: "Total price",
    zipcode: "Zipcode",
    localPrintMedia: "Print media in your region",
    availableEverywhere: "Available everywhere",
    errorSendingForm: 'There was an error sending the form. Please try again later.',
  },
  nl: {
    // Navigation
    brands: "Merken",
    products: "Producten",
    shoppingCart: "Mijn mediaplan",
    myMediaPlan: "Mijn mediaplan",
    backToBrands: "Terug naar Merken",
    
    // Brand Detail
    region: "Regio",
    type: "Type",
    visitWebsite: "Bezoek Website",
    brandNotFound: "Merk niet gevonden",
    brandReach: "Bereik",
    brandPageviews: "Paginaweergaven",
    brandReachRegion: "Regionaal bereik",
    brandReadIntensity: "Leesintensiteit",
    brandReachSocialFollowers: "Social volgers",
    
    // Description Block
    descriptionTitle: "Welkom bij de Mediahuis Tariefcalculator",
    descriptionText: "Met deze tool maak en exporteer je eenvoudig je eigen mediaplan. Op zoek naar digitale, print- of audio-advertenties? Wij hebben het allemaal! Stel je plan samen, vraag direct een offerte aan en ontdek ons uitgebreide aanbod van mediamerken. Ons platform maakt het super makkelijk om opties te verkennen en mediaplannen te maken die perfect bij jouw wensen en budget passen.",
    
    // Slideshow
    slideTitle0: "Mediahuis Tariefcalculator",
    slideSubtitle0: "Ontdek ons uitgebreide media-aanbod",
    slideTitle1: "Adverteren via sterke merken",
    slideSubtitle1: "Ontdek al onze krachtige advertentieproducten op een rij",
    slideTitle2: "Podcast- en radiocampagnes",
    slideSubtitle2: "Val op tussen de oren via onze geliefde podcasts en radiostations",
    slideTitle3: "Digitale advertentieoplossingen",
    slideSubtitle3: "Bereik jouw doelgroep gericht via onze premium digitale platforms",
    slideTitle4: "Geïntegreerde mediacampagnes",
    slideSubtitle4: "Combineer diverse kanalen voor een krachtige en maximale impact",
    slideTitle5: "Regionale en lokale printmedia",
    slideSubtitle5: "Bereik doelgericht specifieke regio's via onze vertrouwde lokale merken",
    
    // Footer
    about: "Over ons",
    quickLinks: "Tariefcalculator",
    contact: "Contact",
    home: "Home",
    cart: "Mediaplan",
    allRightsReserved: "Alle rechten voorbehouden",
    aboutDescription: "De Mediahuis tariefcalculator helpt je snel je advertentietarieven te berekenen. Liever een voorstel op maat? Vraag direct een offerte aan.",
    moreInformation: "Meer informatie",
    ratesAndSpecifications: "Tarieven en specificaties",
    deliverySpecifications: "Aanleverspecificaties",
    onlineAudiences: "Online audiences",
    aboutUs: "Over ons",
    
    // Cart
    emptyCart: "Je mediaplan is leeg",
    addItemsToGetStarted: "Voeg wat items toe vanaf de productpagina's om te beginnen",
    productDetails: "Productdetails",
    mediumType: "Mediumtype",
    calculation: "Berekening",
    calculationLabelsPrint: "Basisprijs × Pos.factor × Form.factor",
    calculationLabelsDigital: "Bereik × Basisprijs × Pos.factor × Form.factor",
    calculationLabelsNieuwsbrief: "Basisprijs × Pos.factor × Form.factor",
    calculationLabelFixedPrice: "Prijs per plaatsing",
    price: "Prijs",
    total: "Totaal",
    clearCart: "Plan wissen",
    applyDiscount: "Korting toevoegen",
    editDiscount: "Korting aanpassen ({discount}%)",
    removeDiscount: "Korting verwijderen",
    exportShoppingCart: "Plan exporteren",
    allItemsHaveDiscount: "Alle items hebben {discount}% korting",
    newItemsReceiveDiscount: "Nieuwe items krijgen automatisch dezelfde korting",
    mixedDiscountsApplied: "Verschillende kortingen toegepast",
    checkIndividualDiscounts: "Bekijk elk item voor de specifieke korting",
    discountLabel: "Korting: {discount}%",
    addDiscount: "Korting toevoegen",
    
    // Calculation section
    calculatePrice: "Prijs berekenen",
    calculationDescription: "Bereken de totale prijs op basis van je campagnebereik. Vul gewoon de CPM-waarde hieronder in.",
    enterBereik: "Vul bereik in (CPM)",
    priceCalculation: "Prijsberekening",
    formulaExplanation: "CPM × Basisprijs = Totale prijs",
    finalPrice: "Eindprijs",
    addToCart: "Toevoegen aan plan",
    addedToCart: "Toegevoegd!",
    additionalInformation: "Meer info",
    additionalInfo: "Extra informatie",
    showDetails: "Details tonen",
    backToProvince: "Terug naar zoeken op postcode",

    
    // Fixed Price Section
    fixedPriceItem: "Vaste prijs item",
    fixedPriceDescription: "Dit is een item met een vaste prijs. Geen berekening nodig.",
    itemPrice: "Item prijs",
    
    // Campaign Calculation
    campaignReach: "Campagne bereik",
    enterValue: "Voer waarde in",
    totalImpressions: "totale impressies",
    totalCampaignCost: "Totale campagnekosten",
    impressions: "Impressies",
    baseRate: "Basistarief",
    positionFactor: "Positiefactor",
    formatFactor: "Formaatfactor",
    
    // Discount Modal
    applyDiscountToAllItems: "Korting toepassen op alle items",
    applyDiscountToItem: "Korting toepassen op item",
    itemDiscountExplanation: "U kunt handmatig een specifieke korting voor dit item toevoegen",
    discountPercentage: "Korting percentage:",
    discountExplanation: "U kunt handmatig specifieke korting voor partners toevoegen",
    cancel: "Annuleren",
    apply: "Korting toepassen",
    applyToAllItems: "Deze korting op alle items toepassen",
    
    // Detail Views
    printMediaDetails: "Printmedia details",
    audioDetails: "Audio details",
    onlineDetails: "Online details",
    publication: "Publicatie",
    formatAndPosition: "Formaat & positie",
    pricing: "Totaal prijs",
    website: "Website",
    formatAndPlacement: "Formaat & plaatsing",
    selectRowToViewDetails: "Selecteer een rij om details te bekijken",
    
    // Fields
    medium: "Medium",
    plaatsingsdag: "Plaatsingsdag",
    tariefbasis: "Tariefbasis",
    basisprijs: "Basisprijs",
    doelgroep: "Doelgroep",
    luisteraars: "Luisteraars",
    bereik: "Bereik",
    impressions: "Impressies",
    station: "Station/programma",
    formatAndTimeslot: "Formaat & tijdslot",
    stationShow: "Station/programma",
    
    // CSV Viewer
    selectMediumtypeAndTitel: "Selecteer zowel mediumtype als titel om resultaten te bekijken",
    noResultsFound: "Geen resultaten gevonden voor de geselecteerde filters",
    productsHeroTitle: "Advertentieproducten",
    productsHeroSubtitle: "Verken ons uitgebreide aanbod van advertentiemogelijkheden in print, audio en online mediakanalen.",
    contactSales: "Contact verkoop",
    
    // Filter Labels
    filterLabelMediumtype: "Mediumtype",
    filterLabelTitel: "Titel",
    filterLabelAandeel: "Pagina aandeel",
    filterLabelFormaat: "Formaat",
    filterLabelPositie: "Positie",
    
    // Selection Modes
    filterSearch: "Handmatig zoeken",
    stepByStepSelection: "Selectie wizard",
    selectMediumtype: "Selecteer mediumtype",
    selectTitel: "Selecteer titel",
    selectFormat: "Selecteer formaat",
    selectPosition: "Selecteer positie",
    selectProduct: "Selecteer product",
    results: "Resultaten",
    loading: "Resultaten laden",
    noResults: "Geen resultaten",
    filterResults: "Filter de resultaten",
    productDetail: "Product detail",
    filtersPreserved: "Je filterselecties zijn behouden in deze weergave",
    backToMediumtype: "Terug naar mediumtype",
    backToTitel: "Terug naar titel",
    backToFormat: "Terug naar formaat",
    backToPosition: "Terug naar positie",
    selectMediumtypeToContinue: "Selecteer een mediumtype om verder te gaan",
    selectTitelToContinue: "Selecteer een titel om verder te gaan",
    selectAandeel: "Selecteer Pagina aandeel",
    selectAandeelFirst: "Selecteer eerst Pagina aandeel",
    selectAandeelToContinue: "Selecteer een Pagina aandeel om beschikbare producten te zien",
    
    // Home Page
    homeSubtitle: "Bereken en beheer advertentietarieven over verschillende mediakanalen",
    startButton: "Start je plan",
    
    // AboutPage/Contact
    contactTitle: "Contact en informatie",
    contactDesc: "Hier vindt u onze contactgegevens en meer informatie over Mediahuis tariefcalculator",
    contactDetails: "Contactgegevens",
    phone: "Telefoon",
    email: "E-mail",
    address: "Adres",
    aboutTheCalculator: "Over de tariefcalculator",
    calculatorPurpose: "Met onze tariefcalculator check je snel en makkelijk de prijzen voor advertenties in al onze media. Zoek op mediatype, titel of regio en vergelijk direct wat het beste bij jou past.",
    calculatorFeatures: "Wat je ermee kunt:",
    featureSearch: "Snel zoeken op mediatype, titel of regio",
    featureCompare: "Prijzen vergelijken van verschillende opties",
    featureExport: "Je mediaplan downloaden",
    featureQuote: "Direct een offerte aanvragen",
    
    // Feature blocks
    createMediaPlan: "Creëer een mediaplan",
    createMediaPlanDesc: "Stel je eigen mediaplan samen door te kiezen uit ons brede aanbod van advertentiemogelijkheden via verschillende kanalen.",
    requestQuoteFeature: "Vraag een offerte aan",
    requestQuoteFeatureDesc: "Krijg persoonlijke prijzen en gedetailleerde informatie door een offerte aan te vragen bij ons verkoopteam.",
    viewAllBrands: "Bekijk alle merken",
    viewAllBrandsDesc: "Verken ons complete portfolio van mediamerken en ontdek de perfecte kanalen voor jouw advertentiecampagne.",
    
    // Custom Select Placeholders
    resetFilter: "Reset",
    selectMediumtypeFirst: "Selecteer eerst Mediumtype",
    selectMediumtypeAndTitelFirst: "Selecteer eerst Mediumtype en Titel",
    selectFormatFirst: "Selecteer eerst Formaat",
    selectGeneric: "Selecteer {field}",
    
    // Old feature blocks (keeping for reference)
    browseProducts: "Bekijk producten",
    browseProductsDesc: "Ontdek ons ruime aanbod aan advertentiemogelijkheden via print, audio en online mediakanalen.",
    manageCart: "Beheer je plan",
    manageCartDesc: "Voeg producten toe aan je plan, pas kortingen toe en exporteer je selecties met een paar klikken.",
    applyDiscounts: "Pas kortingen toe",
    applyDiscountsDesc: "Voeg eenvoudig kortingen toe aan losse items of je hele mediaplan in een handomdraai.",
    
    // Campaign Calculation Instructions
    enterCampaignReach: "Voer het bereik van je campagne in om de prijs te zien.",
    
    // Step Progress
    stepMediumtype: "Medium Type",
    stepTitel: "Title",
    stepFormat: "Format",
    stepPositie: "Position",
    stepAandeel: "Aandeel",
    stepPosition: "Positie",
    
    // Quote Request Form
    requestQuote: 'Offerte aanvragen',
    quoteFormTitle: 'Vraag een offerte aan',
    name: 'Jouw naam',
    company: 'Bedrijf',
    email: 'E-mail',
    phone: 'Telefoonnummer',
    remarks: 'Opmerkingen?',
    productSummary: 'Productsamenvatting',
    cartSummary: 'Plansamenvatting',
    submit: 'Versturen',
    cancel: 'Annuleren',
    requiredField: 'Vul dit even in',
    invalidEmail: 'Vul een geldig e-mailadres in',
    successMessage: 'Bedankt! Je offerte-aanvraag is verzonden!',
    weWillContactYou: 'We nemen snel contact met je op.',
    
    // Region Search
    regionSearch: "Zoeken op postcode",
    searchByRegion: "Zoeken op postcode",
    selectProvince: "Selecteer een provincie om alle beschikbare producten in die regio te zien",
    selectProvincePrintOnly: "Selecteer een provincie om printmedia producten in die regio te zien",
    printMediaOnly: "Alleen Printmedia",
    province: "Provincie",
    selectProvinceToContinue: "Selecteer een provincie om beschikbare producten te zien",
    productsInRegion: "Producten in",
    printProductsInRegion: "Printmedia producten in",
    backToProvince: "Terug naar provincie",
    searchByZipcode: 'Zoeken op postcode',
    enterZipcode: 'Voer postcode in (4 cijfers)',
    completeZipcode: 'Voer een volledige 4-cijferige postcode in',
    enterCompleteZipcode: 'Voer een volledige 4-cijferige postcode in',
    or: 'OF',
    backToZipcode: 'Terug naar postcode',
    printProductsInZipcode: 'Printmedia producten voor postcode',
    includingNationalProducts: 'inclusief landelijke producten',
    selectProvinceOrZipcode: 'Selecteer een provincie of voer een postcode in om beschikbare producten te zien',
    noRegionalTitles: 'Geen regionale titels beschikbaar voor dit gebied',
    selectFormat: 'Selecteer Formaat',
    backToTitle: 'Terug naar Titel',
    selectFormatToContinue: 'Selecteer een formaat om beschikbare producten te zien',
    zipcodeNotFound: 'Geen specifieke regionale producten voor deze postcode beschikbaar',
    totalPrice: "Totaal prijs",
    zipcode: "Postcode",
    localPrintMedia: "Printmedia in jouw regio",
    availableEverywhere: "Landelijk beschikbaar",
    errorSendingForm: 'Er is een fout opgetreden bij het versturen van het formulier. Probeer het later opnieuw.',
  },
  de: {
    // Navigation
    brands: "Marken",
    products: "Produkte",
    shoppingCart: "Mein Mediaplan",
    myMediaPlan: "Mein Mediaplan",
    backToBrands: "Zurück zu Marken",
    
    // Brand Detail
    region: "Region",
    type: "Typ",
    visitWebsite: "Website besuchen",
    brandNotFound: "Marke nicht gefunden",
    brandReach: "Reichweite",
    brandPageviews: "Seitenaufrufe",
    brandReachRegion: "Regionale Reichweite",
    brandReadIntensity: "Leseintensität",
    brandReachSocialFollowers: "Social-Media-Follower",
    
    // Description Block
    descriptionTitle: "Willkommen beim Mediahuis Tarifrechner",
    descriptionText: "Mit diesem Tool kannst du ganz einfach deinen eigenen Medienplan erstellen und exportieren. Suchst du nach digitaler, Print- oder Audio-Werbung? Wir haben alles dabei! Stelle deinen Plan zusammen, fordere direkt ein Angebot an und entdecke unsere umfangreiche Auswahl an Medienmarken. Unsere Plattform macht es super einfach, Optionen zu erkunden und Medienpläne zu erstellen, die perfekt zu deinen Wünschen und deinem Budget passen.",
    
    // Slideshow
    slideTitle0: "Mediahuis Tarifrechner",
    slideSubtitle0: "Entdecken Sie unser umfassendes Medienangebot",
    slideTitle1: "Werbung über starke Marken",
    slideSubtitle1: "Entdecken Sie alle unsere leistungsstarken Werbeprodukte auf einen Blick",
    slideTitle2: "Podcast- und Radiokampagnen",
    slideSubtitle2: "Stechen Sie zwischen den Ohren mit unseren beliebten Podcasts und Radiosendern hervor",
    slideTitle3: "Digitale Werbelösungen",
    slideSubtitle3: "Erreichen Sie Ihre Zielgruppe gezielt über unsere Premium-Digitalplattformen",
    slideTitle4: "Integrierte Medienkampagnen",
    slideSubtitle4: "Kombinieren Sie verschiedene Kanäle für eine starke und maximale Wirkung",
    slideTitle5: "Regionale und lokale Printmedien",
    slideSubtitle5: "Erreichen Sie gezielt bestimmte Regionen über unsere vertrauenswürdigen lokalen Marken",
    
    // Footer
    about: "Über uns",
    quickLinks: "Tarifrechner",
    contact: "Kontakt",
    home: "Startseite",
    cart: "Medienplan",
    allRightsReserved: "Alle Rechte vorbehalten",
    aboutDescription: "Mediahuis Tarifrechner ist ein Tool, das dir hilft, deine Medienplanungskosten zu berechnen und zu verwalten.",
    moreInformation: "Weitere Informationen",
    ratesAndSpecifications: "Tarife und Spezifikationen",
    deliverySpecifications: "Lieferspezifikationen",
    onlineAudiences: "Online-Zielgruppen",
    aboutUs: "Über uns",
    
    // Cart
    emptyCart: "Dein Medienplan ist leer",
    addItemsToGetStarted: "Füge Artikel von den Produktseiten hinzu, um zu beginnen",
    productDetails: "Produktdetails",
    mediumType: "Medientyp",
    calculation: "Berechnung",
    calculationLabelsPrint: "Grundpreis × Pos.faktor × Format.faktor",
    calculationLabelsDigital: "Reichweite × Grundpreis × Pos.faktor × Format.faktor",
    calculationLabelsNieuwsbrief: "Grundpreis × Pos.faktor × Format.faktor",
    calculationLabelFixedPrice: "Preis pro Platzierung",
    price: "Preis",
    total: "Gesamt",
    clearCart: "Plan leeren",
    applyDiscount: "Rabatt hinzufügen",
    editDiscount: "Rabatt bearbeiten ({discount}%)",
    removeDiscount: "Rabatt entfernen",
    exportShoppingCart: "Plan exportieren",
    allItemsHaveDiscount: "Alle Artikel haben {discount}% Rabatt",
    newItemsReceiveDiscount: "Neue Artikel bekommen automatisch denselben Rabatt",
    mixedDiscountsApplied: "Verschiedene Rabatte angewendet",
    checkIndividualDiscounts: "Prüfe jeden Artikel für seinen spezifischen Rabatt",
    discountLabel: "Rabatt: {discount}%",
    addDiscount: "Rabatt hinzufügen",
    
    // Calculation section
    calculatePrice: "Preis berechnen",
    calculationDescription: "Berechne den Gesamtpreis basierend auf der Reichweite deiner Kampagne. Gib einfach den CPM-Wert unten ein.",
    enterBereik: "Reichweite eingeben (CPM)",
    priceCalculation: "Preisberechnung",
    formulaExplanation: "CPM × Grundpreis = Gesamtpreis",
    finalPrice: "Endpreis",
    addToCart: "Zum Plan hinzufügen",
    addedToCart: "Hinzugefügt!",
    additionalInformation: "Mehr Info",
    additionalInfo: "Zusätzliche Informationen",
    showDetails: "Details anzeigen",
    backToProvince: "Zurück zur Postleitzahlensuche",

    
    // Fixed Price Section
    fixedPriceItem: "Artikel mit Festpreis",
    fixedPriceDescription: "Dies ist ein Artikel mit Festpreis. Keine Berechnung nötig.",
    itemPrice: "Artikelpreis",
    
    // Campaign Calculation
    campaignReach: "Kampagnenreichweite",
    enterValue: "Wert eingeben",
    totalImpressions: "Gesamtimpressionen",
    totalCampaignCost: "Gesamtkosten",
    impressions: "Impressionen",
    baseRate: "Grundtarif",
    positionFactor: "Positionsfaktor",
    formatFactor: "Formatfaktor",
    
    // Discount Modal
    applyDiscountToAllItems: "Rabatt auf alle Artikel anwenden",
    applyDiscountToItem: "Rabatt auf Artikel anwenden",
    itemDiscountExplanation: "Du kannst manuell einen Rabatt für diesen Artikel hinzufügen",
    discountPercentage: "Rabatt-Prozentsatz:",
    discountExplanation: "Du kannst manuell Rabatte für Partner hinzufügen",
    cancel: "Abbrechen",
    apply: "Rabatt anwenden",
    applyToAllItems: "Diesen Rabatt auf alle Artikel anwenden",
    
    // Detail Views
    printMediaDetails: "Printmedien-Details",
    audioDetails: "Audio-Details",
    onlineDetails: "Online-Details",
    publication: "Publikation",
    formatAndPosition: "Format & Position",
    pricing: "Preise",
    website: "Webseite",
    formatAndPlacement: "Format & Platzierung",
    selectRowToViewDetails: "Wählen Sie eine Zeile aus, um Details anzuzeigen",
    
    // Fields
    medium: "Medium",
    plaatsingsdag: "Platzierungstag",
    tariefbasis: "Tarifbasis",
    basisprijs: "Grundpreis",
    doelgroep: "Zielgruppe",
    luisteraars: "Zuhörer",
    bereik: "Reichweite",
    impressions: "Impressionen",
    station: "Sender/Sendung",
    formatAndTimeslot: "Format & Zeitfenster",
    stationShow: "Sender/Sendung",
    
    // CSV Viewer
    selectMediumtypeAndTitel: "Bitte wähle Medientyp und Titel aus, um Ergebnisse zu sehen",
    noResultsFound: "Keine Ergebnisse für die ausgewählten Filter gefunden",
    productsHeroTitle: "Werbeangebote",
    productsHeroSubtitle: "Entdecke unsere vielfältigen Werbemöglichkeiten in Print-, Audio- und Online-Medienkanälen.",
    contactSales: "Vertrieb kontaktieren",
    
    // Filter Labels
    filterLabelMediumtype: "Medientyp",
    filterLabelTitel: "Titel",
    filterLabelAandeel: "Seitenanteil",
    filterLabelFormaat: "Format",
    filterLabelPositie: "Position",
    
    // Selection Modes
    filterSearch: "Manuelle Suche",
    stepByStepSelection: "Auswahlassistent",
    selectMediumtype: "Medientyp auswählen",
    selectTitel: "Titel auswählen",
    selectFormat: "Format auswählen",
    selectPosition: "Position auswählen",
    selectProduct: "Produkt auswählen",
    results: "Ergebnisse",
    loading: "Ergebnisse werden geladen",
    noResults: "Keine Ergebnisse",
    filterResults: "Filter de resultaten",
    productDetail: "Produktdetail",
    filtersPreserved: "Deine Filterauswahl wurde beibehalten",
    backToMediumtype: "Zurück zum Medientyp",
    backToTitel: "Zurück zum Titel",
    backToFormat: "Zurück zum Format",
    backToPosition: "Zurück zur Position",
    selectMediumtypeToContinue: "Bitte wähle einen Medientyp aus, um fortzufahren",
    selectTitelToContinue: "Bitte wähle einen Titel aus, um fortzufahren",
    selectAandeel: "Seitenanteil auswählen",
    selectAandeelFirst: "Wähle zuerst Seitenanteil aus",
    selectAandeelToContinue: "Bitte wähle einen Seitenanteil aus, um verfügbare Produkte zu sehen",
    
    // Home Page
    homeSubtitle: "Berechnen und verwalten Sie Werbetarife für verschiedene Medienkanäle",
    startButton: "Starten Sie Ihren Plan",
    
    // AboutPage/Contact
    contactTitle: "Kontakt & Information",
    contactDesc: "Hier finden Sie unsere Kontaktdaten und weitere Informationen über den Mediahuis Tarifrechner",
    contactDetails: "Kontaktdaten",
    phone: "Telefon",
    email: "E-Mail",
    address: "Adresse",
    aboutTheCalculator: "Über den Tarifrechner",
    calculatorPurpose: "Mit unserem Tarifrechner können Sie schnell und einfach die Preise für Anzeigen in all unseren Medien prüfen. Suchen Sie nach Medientyp, Titel oder Region und vergleichen Sie sofort, was am besten zu Ihnen passt.",
    calculatorFeatures: "Was Sie damit machen können:",
    featureSearch: "Schnelle Suche nach Medientyp, Titel oder Region",
    featureCompare: "Preise verschiedener Optionen vergleichen",
    featureExport: "Ihren Medienplan herunterladen",
    featureQuote: "Direkt ein Angebot anfordern",
    
    // Feature blocks
    createMediaPlan: "Erstellen Sie einen Medienplan",
    createMediaPlanDesc: "Stelle deinen eigenen Medienplan zusammen, indem du aus unserem breiten Angebot an Werbemöglichkeiten über verschiedene Kanäle wählst.",
    requestQuoteFeature: "Fordere ein Angebot an",
    requestQuoteFeatureDesc: "Erhalte persönliche Preise und detaillierte Informationen, indem du ein Angebot von unserem Vertriebsteam anforderst.",
    viewAllBrands: "Alle Marken ansehen",
    viewAllBrandsDesc: "Entdecke unser komplettes Portfolio an Medienmarken und finde die perfekten Kanäle für deine Werbekampagne.",
    
    // Custom Select Placeholders
    resetFilter: "Reset",
    selectMediumtypeFirst: "Wähle zuerst Medientyp aus",
    selectMediumtypeAndTitelFirst: "Wähle zuerst Medientyp und Titel aus",
    selectFormatFirst: "Wähle zuerst Format aus",
    selectGeneric: "Wähle {field} aus",
    
    // Old feature blocks (keeping for reference)
    browseProducts: "Produkte entdecken",
    browseProductsDesc: "Schau dir unser breites Angebot an Werbemöglichkeiten in Print-, Audio- und Online-Medienkanälen an.",
    manageCart: "Verwalte deinen Plan",
    manageCartDesc: "Füge Produkte zu deinem Plan hinzu, wende Rabatte an und exportiere deine Auswahl mit wenigen Klicks.",
    applyDiscounts: "Rabatte anwenden",
    applyDiscountsDesc: "Füge ganz einfach prozentuale Rabatte zu einzelnen Artikeln oder deinem gesamten Medienplan hinzu.",
    
    // Campaign Calculation Instructions
    enterCampaignReach: "Gib die Reichweite deiner Kampagne ein, um den Preis zu sehen.",
    
    // Step Progress
    stepMediumtype: "Medium Type",
    stepTitel: "Title",
    stepFormat: "Format",
    stepPositie: "Position",
    stepAandeel: "Share",
    stepPosition: "Position",
    
    // Quote Request Form
    requestQuote: 'Angebot anfordern',
    quoteFormTitle: 'Angebot anfordern',
    name: 'Dein Name',
    company: 'Unternehmen',
    email: 'E-Mail',
    phone: 'Telefonnummer',
    remarks: 'Anmerkungen?',
    productSummary: 'Produktübersicht',
    cartSummary: 'Planübersicht',
    submit: 'Anfrage senden',
    cancel: 'Abbrechen',
    requiredField: 'Bitte ausfüllen',
    invalidEmail: 'Bitte gib eine gültige E-Mail-Adresse ein',
    successMessage: 'Danke! Deine Angebotsanfrage wurde gesendet!',
    weWillContactYou: 'Wir melden uns bald bei dir.',
    
    // Region Search
    regionSearch: "Suche nach Postleitzahl",
    searchByRegion: "Suche nach Postleitzahl",
    selectProvince: "Wähle eine Provinz, um alle verfügbaren Produkte in dieser Region zu sehen",
    selectProvincePrintOnly: "Wähle eine Provinz, um Printmedien-Produkte in dieser Region zu sehen",
    printMediaOnly: "Nur Printmedien",
    province: "Provinz",
    selectProvinceToContinue: "Bitte wähle eine Provinz, um verfügbare Produkte zu sehen",
    productsInRegion: "Produkte in",
    printProductsInRegion: "Printmedien-Produkte in",
    backToProvince: "Zurück zur Provinz",
    searchByZipcode: "Suche nach Postleitzahl",
    enterZipcode: "Postleitzahl eingeben (4 Ziffern)",
    completeZipcode: "Geben Sie eine vollständige 4-stellige Postleitzahl ein",
    enterCompleteZipcode: "Bitte geben Sie eine vollständige 4-stellige Postleitzahl ein",
    or: "ODER",
    backToZipcode: "Zurück zur Postleitzahl",
    printProductsInZipcode: "Printmedien-Produkte für Postleitzahl",
    includingNationalProducts: "einschließlich nationaler Produkte",
    selectProvinceOrZipcode: "Bitte wählen Sie eine Provinz oder geben Sie eine Postleitzahl ein, um verfügbare Produkte zu sehen",
    noRegionalTitles: "Keine regionalen Titel für dieses Gebiet verfügbar",
    selectFormat: "Format auswählen",
    backToTitle: "Zurück zum Titel",
    selectFormatToContinue: "Bitte wählen Sie ein Format, um verfügbare Produkte zu sehen",
    zipcodeNotFound: "Keine spezifischen regionalen Produkte für diese Postleitzahl verfügbar",
    totalPrice: "Gesamtpreis",
    zipcode: "Postleitzahl",
    localPrintMedia: "Printmedien in Ihrer Region",
    availableEverywhere: "Überall verfügbar",
    errorSendingForm: 'Er is een fout opgetreden bij het versturen van het formulier. Probeer het later opnieuw.',
  }
};

export default translations; 